import { render, staticRenderFns } from "./Category.vue?vue&type=template&id=41cccf94&scoped=true&"
import script from "./Category.vue?vue&type=script&lang=js&"
export * from "./Category.vue?vue&type=script&lang=js&"
import style0 from "./Category.vue?vue&type=style&index=0&id=41cccf94&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41cccf94",
  null
  
)

export default component.exports